import React from "react";
import classnames from "classnames";
import { formatTagUIds } from "services";
import { Skeleton } from "..";

const Text = ({
  description,
  label,
  tagUid,
  danger,
  strong,
  italic,
  underline,
  error,
  modalTitle,
  size = "text-sm",
  color = "text-black",
  children,
  className,
  uppercase,
  capitalize,
  fontWeight = "font-normal",
  classes = {},
  fontMono,
  breakAll,
  receiptContent,
  loading,
}) => {
  const classStyle = classnames(
    {
      ...classes,
      "text-red": danger,
      "font-medium": strong,
      italic: italic,
      underline: underline,
      uppercase: uppercase,
      capitalize: capitalize,
      "font-mono font-bold": fontMono,
      "break-all": breakAll,
      "break-word": !breakAll,
    },
    className
  );

  if (loading) {
    return <Skeleton double />;
  }

  if (description) {
    return <p className={classnames("text-xs text-black", classStyle)}>{children}</p>;
  }

  if (label) {
    return (
      <div className={classnames("text-xs font-small text-gray-lighter", classStyle)}>
        {children}
      </div>
    );
  }

  if (tagUid) {
    return (
      <p
        className={classnames(
          `text-sm font-mono font-bold ${color || "text-gray-lighter"}`,
          classStyle
        )}
      >
        {formatTagUIds(children)}
      </p>
    );
  }

  if (error) {
    return <p className={classnames("text-xs text-red", classStyle)}>{children}</p>;
  }

  if (modalTitle) {
    return (
      <p className={classnames("text-md text-black-light font-bold", classStyle)}>{children}</p>
    );
  }

  if (receiptContent) {
    return (
      <p className={classnames("text-xs text-black-dark font-normal font-mono p-0", classStyle)}>
        {children}
      </p>
    );
  }

  return <p className={classnames(`${fontWeight} ${size} ${color}`, classStyle)}>{children}</p>;
};

export default Text;
